import { POST } from 'js/constants/requestMethods';
import { CALL_PRIVATE_API } from 'js/constants/api';
import {
  GET_FLOW_RUN_LOGS_WITH_FACETS_REQUEST_V2,
  GET_FLOW_RUN_LOGS_WITH_FACETS_SUCCESS_V2,
  GET_FLOW_RUN_LOGS_WITH_FACETS_FAILURE_V2,
  GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_REQUEST_V2,
  GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_SUCCESS_V2,
  GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_FAILURE_V2,
} from 'js/constants/actionTypes';

type ParamsType = {
  from?: number;
  to?: number;
  size?: number;
  sort?: 'asc' | 'desc';
  facets?: boolean;
};

export type Options = {
  params: ParamsType;
  body: {
    pagination: {
      search_after_values: [number, string];
    };
    run_ids: string[];
    data_sources: string[];
    data_sinks: string[];
    data_sets: string[];
    flow_ids: string[];
    severity: string[];
    log_type: string[]; // LOG or EVENT
  };
};

const buildParams = (options?: Options): string => {
  const urlParams = new URLSearchParams({
    facets: options?.params?.facets ?? 'true',
    size: options?.params?.size?.toString() ?? '100',
    sort: options?.params?.sort ?? 'asc',
  } as any);

  if (options?.params?.to) {
    urlParams.set('to', options?.params?.to?.toString());
  }

  if (options?.params?.from) {
    urlParams.set('from', options?.params?.from?.toString());
  }

  return urlParams.toString();
};

export const fetchFlowRunLogsWithFacets = (flowNodeId: string, options?: Options) => (dispatch) => {
  const endpoint = `/flows/${flowNodeId}/logs_v2?${buildParams(options ?? { params: {}, body: {} as any })}`;

  const payload = options?.body ?? {};

  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        GET_FLOW_RUN_LOGS_WITH_FACETS_REQUEST_V2,
        GET_FLOW_RUN_LOGS_WITH_FACETS_SUCCESS_V2,
        GET_FLOW_RUN_LOGS_WITH_FACETS_FAILURE_V2,
      ],
      payload,
      schema: null,
      endpoint,
      requestMethod: POST,
      requestInfo: {
        flowNodeId,
        sortOrder: options?.params?.sort ?? 'asc',
        search_after_values: options?.body?.pagination?.search_after_values,
      },
    },
  });
};

/**
 * Auto-refresh variant that preserves pagination state
 * Used for periodic auto-refresh to avoid resetting user's pagination context
 */
export const fetchFlowRunLogsWithFacetsAutoRefresh =
  (flowNodeId: string, options?: Options) => (dispatch) => {
    const endpoint = `/flows/${flowNodeId}/logs_v2?${buildParams(options ?? { params: {}, body: {} as any })}`;

    const payload = options?.body ?? {};

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_REQUEST_V2,
          GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_SUCCESS_V2,
          GET_FLOW_RUN_LOGS_WITH_FACETS_AUTO_REFRESH_FAILURE_V2,
        ],
        payload,
        schema: null,
        endpoint,
        requestMethod: POST,
        requestInfo: {
          flowNodeId,
          sortOrder: options?.params?.sort ?? 'asc',
          search_after_values: options?.body?.pagination?.search_after_values,
        },
      },
    });
  };
